import { createSlice, PayloadAction } from '@reduxjs/toolkit'
declare global {
    interface Window {
        Restaurant?: {
            restaurantId: string
            logo: string
            servedVersion: string
            name: string
            phoneNumber: string
            emailAddress: string
            baseUrls: string[]
        }
    }
}
export interface Restaurant {
    restaurantId: string
    logo: string
    servedVersion: string
    name: string
    phoneNumber: string
    emailAddress: string
    baseUrls: string[]
}
interface RestaurantState {
    restaurant: Restaurant | null
    isLoaded: boolean
}
const initialState: RestaurantState = {
    restaurant: null,
    isLoaded: false,
}
export const restaurantSlice = createSlice({
    name: 'restaurant',
    initialState,
    reducers: {
        setRestaurant: (state, action: PayloadAction<Restaurant>) => {
            state.restaurant = action.payload
            state.isLoaded = true
        },
        clearRestaurant: (state) => {
            state.restaurant = null
            state.isLoaded = false
        },
        loadRestaurantFromWindow: (state) => {
            if (window.Restaurant) {
                state.restaurant = window.Restaurant
                state.isLoaded = true
            } else {
                console.warn('window.Restaurant is not available')
            }
        },
    },
})
export const { setRestaurant, clearRestaurant, loadRestaurantFromWindow } = restaurantSlice.actions
export const selectRestaurant = (state: { restaurant: RestaurantState }) => state.restaurant.restaurant
export const selectIsRestaurantLoaded = (state: { restaurant: RestaurantState }) => state.restaurant.isLoaded
export default restaurantSlice.reducer